import { callExternalApi } from './external-api.service'
import API_PATHS from '../constants/API_PATHS'

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL

/* Open Banking Customer */

export const svc_createOBCustomer = async (accessToken, userId, openBankingObj) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.CREATE_OB_CUSTOMER(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: openBankingObj,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getOBCustomer = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_OB_CUSTOMER(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_updateOBCustomer = async (accessToken, userId, openBankingObj) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.UPDATE_OB_CUSTOMER(userId)}`,
        method: 'PUT',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: openBankingObj,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_deleteOBCustomer = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.DELETE_OB_CUSTOMER(userId)}`,
        method: 'DELETE',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}


/* Open Banking Customer Account */

export const svc_createOBCustomerAccount = async (accessToken, userId, openBankingObj) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.CREATE_OB_CUSTOMER_ACCOUNT(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: openBankingObj,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getOBCustomerAccount = async (accessToken, userId, customerId, accountId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_OB_CUSTOMER_ACCOUNT(userId, customerId, accountId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getOBCustomerAccounts = async (accessToken, userId, customerId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_OB_CUSTOMER_ACCOUNTS(userId, customerId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_updateOBCustomerAccount = async (accessToken, userId, openBankingObj) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.UPDATE_OB_CUSTOMER_ACCOUNT(userId)}`,
        method: 'PUT',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: openBankingObj,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_deleteOBCustomerAccount = async (accessToken, userId, accountId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.DELETE_OB_CUSTOMER_ACCOUNT(userId, accountId)}`,
        method: 'DELETE',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}